import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import ProcessingSubsection from "./ProcessingSubsection";
import "./ProcessingService.css";

export default function ProcessingService(props) {
  const customPropValue = props.location?.state?.customProp;
  return (
    <>
      <UpdatesBanner
        className="processingServiceBg"
        bannerText={["Business Growth Service"]}
      />
      <ProcessingSubsection customPropValue={customPropValue} />
    </>
  );
}
